/**
 * Per-image analytics pushed into the Appearance preview frame.
 * Empty outside the admin preview, so public visitors never see overlays.
 */

import { useSyncExternalStore } from 'react';

let imageById = {};
const listeners = new Set();

export function setPreviewImageAnalytics(next) {
    imageById = next && typeof next === 'object' ? next : {};
    listeners.forEach((listener) => listener());
}

function subscribe(listener) {
    listeners.add(listener);
    return () => listeners.delete(listener);
}

function getSnapshot() {
    return imageById;
}

// React 19 caches this by reference — a fresh `{}` each call causes an update loop.
const EMPTY_SERVER_SNAPSHOT = Object.freeze({});

function getServerSnapshot() {
    return EMPTY_SERVER_SNAPSHOT;
}

/** Analytics map for the current Appearance preview page, keyed by image id. */
export function usePreviewImageAnalyticsMap() {
    return useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
}

/** Analytics for one masonry tile, or null when none. */
export function usePreviewImageAnalytics(imageId) {
    const map = usePreviewImageAnalyticsMap();
    if (!imageId) return null;
    return map[imageId] || null;
}
